const weights: any = {
  attacktype: [
    'malware',
    'intrusion',
    'encrypted threats',
    'ransomware',
    '0-Day Threats',
    'Spam',
    'Phishing',
    '0-day Attachments',
    'Malicious URLs',
    'Malware(on cloud storage)',
    'Cloud Data Loss',
    'Malware (off-network)',
    'Intrusions (off-network)',
    'Ransomware (off-network)',
    '0-Day Threats (off-network)',
    'Undetectable Threats',
  ],
  rw: [
    2,
    2,
    3,
    3,
    3,
    1,
    2,
    3,
    2,
    2,
    2,
    2,
    2,
    3,
    3,
    2,
  ],
  lw: [
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
  ],
};

const SSCV2: any = {
  attacktype: [
    'email_total',
    'zerodayattachment',
    'malware',
    'email_likely_spam',
    'email_fraud',
    'Spam',
    'email_dha',
    'email_likely_virus',
    'email_virus',
    'email_likely_fraud',
    'email_good',
    'ransomware',
    'intrusion',
    'email_likely_spoof',
    'malwarehttps',
    'email_policy',
    'capture',
    'Phishing',
    'email_spam',
  ],
  sncount: [
    4772,
    -1,
    182481,
    4772,
    4772,
    4772,
    4772,
    4772,
    4772,
    4772,
    4772,
    3941,
    304385,
    4772,
    2209,
    4772,
    36716,
    4772,
    4772,
  ],
  hits: [
    304477648,
    8709,
    724945891,
    13301833,
    159316,
    119740083,
    22558403,
    212,
    218630,
    8,
    140010593,
    22219232,
    334297008135,
    530962,
    102055,
    43817844,
    0,
    690286,
    83879847,
  ],
  avg: [
    '  63805',
    '  -8709',
    '   3973',
    '   2787',
    '     33',
    '  25092',
    '   4727',
    '      0',
    '     46',
    '      0',
    '  29340',
    '   5638',
    '1098270',
    '    111',
    '     46',
    '   9182',
    '      0',
    '    145',
    '  17578',
  ],
};

import zeroDayAttachment from './assets/icon_risk_meters/Icon_0day_Attachments.svg';
import zeroDayThreatsOffNetwork from './assets/icon_risk_meters/Icon_0day_Threats_Off-Network.svg';
import zeroDayThreats from './assets/icon_risk_meters/Icon_0day_Threats.svg';
import cloudDataLoss from './assets/icon_risk_meters/Icon_Cloud_Data_Loss.svg';
import intrusionsOffNetwork from './assets/icon_risk_meters/Icon_Intrusions_Off-Network.svg';
import malwareOffNetwork from './assets/icon_risk_meters/Icon_Malware_Off-Network.svg';
import malwareOnCloud from './assets/icon_risk_meters/Icon_Malware_on_Cloud.svg';
import malware from './assets/icon_risk_meters/Icon_Malware.svg';
import phishing from './assets/icon_risk_meters/Icon_Phishing.svg';
import ransomwareOffNetwork from './assets/icon_risk_meters/Icon_Ransomware_Off-Network.svg';
import undetectableThreats from './assets/icon_risk_meters/Icon_Undetectable_Threats.svg';

const threats: Threat[] = [
  {
    id: 0,
    title: 'Malware',
    show: true,
    layer: 3,
    icon: '\uf1ae',
    iconName: 'threat-spyware',
    color: '#18B7A4',
    magnitude: 40,
    isPenetrating: false,
    isCursorOver: false,
    far: 0,
    innerLayer: 2,
    SSCV2ArrayIndex: 1,
    svg: true,
    image: malware,
    globalIndex: -1,
  },
  {
    id: 1,
    title: 'Intrusion',
    show: true,
    layer: 3,
    icon: '\uf1ac',
    iconName: 'threat-intrusion',
    color: '#CE8ABC',
    magnitude: 40,
    isPenetrating: false,
    isCursorOver: false,
    far: 0,
    innerLayer: 2,
    SSCV2ArrayIndex: 4,
    svg: false,
    globalIndex: -1,
  },
  {
    id: 2,
    title: 'Ransomware',
    show: false,
    layer: 3,
    icon: '\uf1f6',
    iconName: 'unique-ransomware',
    color: '#E2509A',
    magnitude: 40,
    isPenetrating: false,
    isCursorOver: false,
    far: 0,
    innerLayer: 1,
    // SSCV2ArrayIndex: 3,
    SSCV2ArrayIndex: -1,
    svg: false,
    globalIndex: -1,
  },
  {
    id: 3,
    title: '0 Day Threats',
    show: true,
    layer: 3,
    icon: '\uf1ac',
    iconName: 'threat-intrusion',
    color: '#7A7EB4',
    magnitude: 40,
    isPenetrating: false,
    isCursorOver: false,
    far: 0,
    innerLayer: 1,
    SSCV2ArrayIndex: -1,
    svg: true,
    image: zeroDayThreats,
    globalIndex: -1,
  },
  {
    id: 4,
    title: 'Web App Attacks',
    show: true,
    layer: 3,
    icon: '\ue920',
    iconName: 'service-waf',
    color: '#68BBE7',
    magnitude: 40,
    isPenetrating: false,
    isCursorOver: false,
    far: 0,
    innerLayer: 0,
    SSCV2ArrayIndex: 5,
    svg: false,
    globalIndex: -1,
  },
  {
    id: 5,
    title: 'Phishing',
    show: true,
    layer: 2,
    icon: '\uF00C',
    iconName: 'user-profile',
    color: '#BADB77',
    magnitude: 40,
    isPenetrating: false,
    isCursorOver: false,
    far: 0,
    SSCV2ArrayIndex: -1,
    svg: true,
    image: phishing,
    globalIndex: -1,
    innerLayer: 0,
  },
  {
    id: 6,
    title: 'Malicious Attachments',
    show: true,
    layer: 2,
    icon: '\uF032',
    iconName: 'android',
    color: '#609af7',
    magnitude: 40,
    isPenetrating: false,
    isCursorOver: false,
    far: 0,
    SSCV2ArrayIndex: -1, // 6,
    svg: true,
    image: zeroDayAttachment,
    globalIndex: -1,
    innerLayer: 0,
  },
  {
    id: 7,
    title: 'Malicious URLs',
    show: false,
    layer: 2,
    icon: '\uf1ab',
    iconName: 'url',
    color: 'red',
    magnitude: 40,
    isPenetrating: false,
    isCursorOver: false,
    far: 0,
    SSCV2ArrayIndex: 8,
    svg: false,
    globalIndex: -1,
    innerLayer: 0,
  },
  {
    id: 8,
    title: 'Malware on Cloud',
    show: true,
    layer: 2,
    icon: '\uEf1C',
    iconName: 'tux',
    color: '#80D8E0',
    magnitude: 40,
    isPenetrating: false,
    isCursorOver: false,
    far: 0,
    SSCV2ArrayIndex: -1,
    svg: true,
    image: malwareOnCloud,
    globalIndex: -1,
    innerLayer: 1,
  },
  {
    id: 9,
    title: 'Cloud Data Loss',
    show: true,
    layer: 2,
    icon: '\uf1ae',
    iconName: 'virtual-assist',
    color: '#18B7A4',
    magnitude: 40,
    isPenetrating: false,
    isCursorOver: false,
    far: 0,
    SSCV2ArrayIndex: -1,
    svg: true,
    image: cloudDataLoss,
    globalIndex: -1,
    innerLayer: 1,
  },
  {
    id: 10,
    title: 'Endpoint Malware',
    show: true,
    layer: 1,
    icon: '\uf1ae',
    iconName: 'virtual-assist',
    color: '#f9ae45',
    magnitude: 40,
    isPenetrating: false,
    isCursorOver: false,
    far: 0,
    SSCV2ArrayIndex: -1,
    svg: true,
    image: malwareOffNetwork,
    globalIndex: -1,
    innerLayer: 0,
  },
  {
    id: 11,
    title: 'Endpoint Exploits',
    show: true,
    layer: 1,
    icon: '\uf1ae',
    iconName: 'virtual-assist',
    color: '#e445f9',
    magnitude: 40,
    isPenetrating: false,
    isCursorOver: false,
    far: 0,
    SSCV2ArrayIndex: -1,
    svg: true,
    image: intrusionsOffNetwork,
    globalIndex: -1,
    innerLayer: 0,
  },
  {
    id: 12,
    title: 'Ransomware (Off Network)',
    show: false,
    layer: 1,
    icon: '\uf1ae',
    iconName: 'virtual-assist',
    color: '#45f94b',
    magnitude: 40,
    isPenetrating: false,
    isCursorOver: false,
    far: 0,
    SSCV2ArrayIndex: -1,
    svg: true,
    image: ransomwareOffNetwork,
    globalIndex: -1,
  },
  {
    id: 13,
    title: '0 Day Threats (ATP)',
    show: true,
    layer: 1,
    icon: '\uf1ae',
    iconName: 'virtual-assist',
    color: '#ff4470',
    magnitude: 40,
    isPenetrating: false,
    isCursorOver: false,
    far: 0,
    SSCV2ArrayIndex: -1,
    svg: true,
    image: zeroDayThreatsOffNetwork,
    globalIndex: -1,
    innerLayer: 1,
  },
  {
    id: 14,
    title: 'Rollbacks',
    show: true,
    layer: 1,
    icon: '\ue908',
    iconName: 'rollback',
    color: '#4683fc',
    magnitude: 40,
    isPenetrating: false,
    isCursorOver: false,
    far: 0,
    SSCV2ArrayIndex: -1,
    svg: true,
    image: undetectableThreats,
    globalIndex: -1,
    innerLayer: 1,
  },
];

export default threats;
export  { SSCV2, weights };

export interface Threat {
  id: number;
  show: boolean;
  layer:number;
  icon:string;
  color:string;
  magnitude:number;
  isPenetrating:boolean;
  isCursorOver: boolean;
  iconName: string;
  far: number;
  title: string;
  innerLayer?: number;
  SSCV2ArrayIndex: number;
  svg: boolean;
  image?: typeof import('*.svg');
  globalIndex: number;
}
